// VOY-485 (rebuild) — Traveler stats (Public profile tab).
//
// Four stats: countries / cities / trips booked / saved w/ Voy.
//   - First three: real DB aggregations via getTravelerStats.
//   - "Saved w/ Voy": STUB until VOY-420 ships. Renders an em-dash + the
//     "PENDING" eyebrow so the slot is honest. The savings figure is
//     standard supplier price minus subscription-discounted price; the
//     pricing module is mid-rebuild (VOY-420). Do NOT compute savings here.

import type { TravelerStats } from '@/lib/profile'

export interface TravelerStatsSectionProps {
  stats: TravelerStats | null
}

function fmt(n: number): string {
  return new Intl.NumberFormat().format(n)
}

export function TravelerStatsSection({ stats }: TravelerStatsSectionProps) {
  const s: TravelerStats = stats ?? {
    countries_visited: 0,
    cities_visited: 0,
    trips_booked: 0,
    saved_with_voy: null,
  }
  return (
    <section className="card" aria-labelledby="stats-h">
      <div className="card-h">
        <h3 id="stats-h">Traveler stats</h3>
        <span className="meta">ALL TIME</span>
      </div>
      <div className="profile-stats">
        <div>
          <div className="lbl">COUNTRIES</div>
          <span className="num">{fmt(s.countries_visited)}</span>
        </div>
        <div>
          <div className="lbl">CITIES</div>
          <span className="num">{fmt(s.cities_visited)}</span>
        </div>
        <div>
          <div className="lbl">TRIPS BOOKED</div>
          <span className="num">{fmt(s.trips_booked)}</span>
        </div>
        <div className="stat-stub">
          <div className="lbl">SAVED W/ VOY · PENDING</div>
          <span className="num" aria-label="Pending savings calculation">—</span>
        </div>
      </div>
    </section>
  )
}
